import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { GameHistoryData } from "./GameHistoryData";

const GameHistory = () => {
  document.title = "User Game History Details| mrmto";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title="mrmto"
            breadcrumbItem="User Game History Details"
          />
          <GameHistoryData />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default GameHistory;
